import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-coach-players-profile" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "app-coach-players-profile-root" }
const _hoisted_4 = { class: "wrapper-profile" }
const _hoisted_5 = { class: "section-default" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Profil ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CoachNavigationVue = _resolveComponent("CoachNavigationVue")!
  const _component_CoachPlayersProfileNavigationVue = _resolveComponent("CoachPlayersProfileNavigationVue")!
  const _component_CoachPlayersProfileRootMatchesIndexVue = _resolveComponent("CoachPlayersProfileRootMatchesIndexVue")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_CoachPlayersProfileRootTrainingsIndexVue = _resolveComponent("CoachPlayersProfileRootTrainingsIndexVue")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CoachPlayersProfileRootUserInformationIndexVue = _resolveComponent("CoachPlayersProfileRootUserInformationIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CoachNavigationVue),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CoachPlayersProfileNavigationVue),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_row, {
              gutter: 16,
              type: "flex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 12,
                  lg: 12,
                  xl: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CoachPlayersProfileRootMatchesIndexVue)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 12,
                  lg: 12,
                  xl: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CoachPlayersProfileRootTrainingsIndexVue)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_CoachPlayersProfileRootUserInformationIndexVue)
        ])
      ])
    ])
  ]))
}